
import { Component, OnInit } from '@angular/core';
import { TimeAgoPipe } from '../../../../utils/pipe/time-ago.pipe';
import { UtcToLocalPipe } from '../../../../utils/pipe/utc-to-local.pipe';
import { NewsService } from '../news.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { ThumbnailPipe } from '../../../../utils/pipe/thumbnail.pipe'; 


@Component({
  selector: 'app-news-right-sidebar',
  templateUrl: './news-right-sidebar.component.html',
  styleUrls: ['./news-right-sidebar.component.scss'],
  providers: [TimeAgoPipe, UtcToLocalPipe,ThumbnailPipe]

})
export class NewsRightSidebarComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, private NewsService: NewsService, private timeAgoPipe: TimeAgoPipe, private utcToLocalPipe: UtcToLocalPipe, private thumbnailPipe:ThumbnailPipe) { }

  private baseUrl = environment.apiUrl;
  id: string | null = null;
  topNews: any;
  archives: any;
  categories: any;
  newsList: any;
  searched: string = '';
  searchInput: string = '';
  filter: string = '';
  current_category: string = '';
  current_archive: string = '';
  currentPage = 1; // Página inicial
  pageSize = 6; // Tamaño de página
  totalItems = 0; // Total de objetos desde el backend
  totalPages = 0; // Total de páginas calculadas
  receivedData: any;


  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;

      if (this.filter == '') {
        this.loadData();
      }
      else if (this.filter == 'search') {

        this.NewsService.getNewsByTitleOrContent(this.currentPage, this.pageSize, this.searchInput).subscribe((response: any) => {
          response.data.forEach((item:any) => {
            item['imageUrl'] = this.thumbnailPipe.transform(this.baseUrl+item['imageUrl']);

          });
          this.newsList = response.data;
          this.totalItems = response.totalCount;
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);
        });



      }
      else if (this.filter == 'archive') {
        this.searchInput = "";

        this.NewsService.getNewsByArchive(this.currentPage, this.pageSize, this.current_archive['date']).subscribe((response) => {
          response.data.forEach((item:any) => {
            item['imageUrl'] = this.thumbnailPipe.transform(this.baseUrl+item['imageUrl']);
          });
          this.newsList = response.data;
          this.totalItems = response.totalCount;
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);
        });
      }

      else if (this.filter == 'category') {
        this.searchInput = "";

        this.NewsService.getNewsByCategory(this.currentPage, this.pageSize, this.current_category['category']).subscribe((response) => {
          response.data.forEach((item:any) => {
            item['imageUrl'] = this.thumbnailPipe.transform(this.baseUrl+item['imageUrl']);
          });
          this.newsList = response.data;
          this.totalItems = response.totalCount;
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);
        });
      }
    }
  }

  get totalPagesArray(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  loadData() {
    this.NewsService.getNewsByTitleOrContent(this.currentPage, this.pageSize, '').subscribe((response: any) => {


      response.data.forEach((item:any) => {
        item['imageUrl'] = this.thumbnailPipe.transform(this.baseUrl+item['imageUrl']);

      });
      this.newsList = response.data;
      this.totalItems = response.totalCount;
      this.totalPages = Math.ceil(this.totalItems / this.pageSize);

    });

    this.NewsService.getTopNews().subscribe((response) => {
      response.forEach((item:any) => {
        item['image'] = this.thumbnailPipe.transform(this.baseUrl+item['image']);

      });
      this.topNews = response;
    });


    this.NewsService.getArchives().subscribe((response) => {
      response.forEach(element => {
        element['dateParsed'] = this.formatDate(element.date)
      });
      this.archives = response;
    });

    this.NewsService.getCategories().subscribe((response) => {
      this.categories = response;
    });
  }


  goToNews(element: any) {
    this.router.navigate(['/news/view/', element.id]);
  }


  formatDate(dateString: string): string {
    const monthNames = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    const [month, year] = dateString.split('-');
    return `${monthNames[+month - 1]} - ${year}`;
  }

  searchByTitleOrContent() {
    this.categories.forEach((element: any) => {
      element['isActive'] = false;
    });
    this.archives.forEach((element: any) => {
      element['isActive'] = false;
    });
    this.currentPage = 1;
    this.filter == 'search'
    this.NewsService.getNewsByTitleOrContent(this.currentPage, this.pageSize, this.searchInput).subscribe((response) => {
      
      response.data.forEach((item) => {
        item['imageUrl'] = this.thumbnailPipe.transform(this.baseUrl+item['imageUrl']);

      });
      this.newsList = response.data;
      this.totalItems = response.totalCount;
      this.totalPages = Math.ceil(this.totalItems / this.pageSize);
      this.searched = structuredClone(this.searchInput);
    });
  }


  searchByArchive(item: any) {
    this.searchInput = "";
    this.filter = "archive";
    this.current_archive = item;

    this.markSelection(item);
    this.currentPage = 1;
    this.NewsService.getNewsByArchive(this.currentPage, this.pageSize, item.date).subscribe((response) => {
      response.data.forEach((item) => {
        item['imageUrl'] = this.thumbnailPipe.transform(this.baseUrl+item['imageUrl']);
      });
      this.newsList = response.data;
      this.totalItems = response.totalCount;
      this.totalPages = Math.ceil(this.totalItems / this.pageSize);
    });
  }

  markSelection(item: any) {
    if (!item['isActive']) {
      this.categories.forEach((element: any) => {
        element['isActive'] = false;
      });
      this.archives.forEach((element: any) => {
        element['isActive'] = false;
      });
      item['isActive'] = true;
    } else {
      
      this.categories.forEach((element: any) => {
        element['isActive'] = false;
      });
      this.archives.forEach((element: any) => {
        element['isActive'] = false;
      });
      this.NewsService.getNewsByTitleOrContent(this.currentPage, this.pageSize, '').subscribe((response) => {
        this.filter = ''
        response.data.forEach((item) => {
          item['imageUrl'] = this.thumbnailPipe.transform(this.baseUrl+item['imageUrl']);
        });
        this.newsList = response.data;
        this.totalItems = response.totalCount;
        this.totalPages = Math.ceil(this.totalItems / this.pageSize);
        this.searched = structuredClone(this.searchInput);
      });
    }
  }



  searchByCategory(item: any) {
    this.searchInput = "";
    this.filter = "category";
    this.current_category = item;
    this.currentPage = 1;
    this.markSelection(item)

    this.NewsService.getNewsByCategory(this.currentPage, this.pageSize, item.category).subscribe((response) => {
      response.data.forEach((item) => {

        item['imageUrl'] = this.thumbnailPipe.transform(this.baseUrl+item['imageUrl']);
      });
      this.newsList = response.data;
      this.totalItems = response.totalCount;
      this.totalPages = Math.ceil(this.totalItems / this.pageSize);
    });
  }



  ngOnInit(): void {
    this.receivedData = history.state;

    history.replaceState(null, '', this.router.url);
    if (this.receivedData.filter === undefined) {
      this.loadData();
    }
    else if (this.receivedData.filter == 'search') {

      this.NewsService.getNewsByTitleOrContent(this.currentPage, this.pageSize, this.receivedData.value).subscribe((response: any) => {
        response.data.forEach((item) => {
          item['imageUrl'] = this.thumbnailPipe.transform(this.baseUrl+item['imageUrl']);
        });
        this.newsList = response.data;
        this.totalItems = response.totalCount;
        this.totalPages = Math.ceil(this.totalItems / this.pageSize);
        this.searched = this.receivedData.value;

      });


      this.NewsService.getTopNews().subscribe((response) => {
        response.forEach((item) => {
          item['image'] = this.thumbnailPipe.transform(this.baseUrl+item['image']);

        });
        this.topNews = response;
      });


      this.NewsService.getArchives().subscribe((response) => {
        response.forEach(element => {
          element['dateParsed'] = this.formatDate(element.date)
        });
        this.archives = response;
      });

      this.NewsService.getCategories().subscribe((response) => {
        this.categories = response;
      });

    }
    else if (this.receivedData.filter == 'archive') {
      this.NewsService.getArchives().subscribe((response) => {
        response.forEach(element => {
          element['dateParsed'] = this.formatDate(element.date)
        });
        this.archives = response;

        this.NewsService.getCategories().subscribe((response) => {
          this.categories = response;

          this.archives.forEach(element => {
            if (element.date == this.receivedData.value.date) {
              this.markSelection(element)
            }
          });
        });
        this.NewsService.getNewsByArchive(this.currentPage, this.pageSize, this.receivedData.value.date).subscribe((response) => {
          response.data.forEach((item) => {
            item['imageUrl'] = this.thumbnailPipe.transform(this.baseUrl+item['imageUrl']);

          });
          this.newsList = response.data;
          this.totalItems = response.totalCount;
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);
        });
      });

      this.NewsService.getTopNews().subscribe((response) => {
        response.forEach((item) => {
          item['image'] = this.thumbnailPipe.transform(this.baseUrl+item['image']);

        });
        this.topNews = response;
      });
    }

    else if (this.receivedData.filter == 'category') {
      this.NewsService.getArchives().subscribe((response) => {
        response.forEach(element => {
          element['dateParsed'] = this.formatDate(element.date)
        });
        this.archives = response;
        this.NewsService.getCategories().subscribe((response) => {
          this.categories = response;

          this.categories.forEach(element => {
            if (element.category == this.receivedData.value.category) {
              this.markSelection(element)
            }
          });
        });
        this.NewsService.getNewsByCategory(this.currentPage, this.pageSize, this.receivedData.value.category).subscribe((response) => {
          response.data.forEach((item) => {
            item['imageUrl'] = this.thumbnailPipe.transform(this.baseUrl+item['imageUrl']);
          });
          this.newsList = response.data;
          this.totalItems = response.totalCount;
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);
        });
      });

      this.NewsService.getTopNews().subscribe((response) => {
        response.forEach((item) => {
          item['image'] = this.thumbnailPipe.transform(this.baseUrl+item['image']);
        });
        this.topNews = response;
      });
    }
  }
}
